export function loadCategoryTreeList(layloadCallback) {
    const categoryTreeListContainer = document.querySelector('[data-treelisturl]');
    if (!categoryTreeListContainer) {
        return;
    }
    const url = categoryTreeListContainer.getAttribute("data-treelisturl");
    if (!url) {
        return;
    }

    fetch(url)
        .then(response => {
            if (response?.status === 200) {
                return response.json();
            }
        })
        .then(json => {
            if (json.items) {
                categoryTreeListContainer.innerHTML = json.items;
                layloadCallback();
            }
        })
        .catch(e => console.error(e))
}